
export const es = {
  auth: {
    login: "Iniciar sesión",
    startFreeTrial: "Comenzar prueba gratuita",
    register: "Registrarse",
    email: "Correo electrónico",
    password: "Contraseña",
    forgotPassword: "¿Olvidaste tu contraseña?",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    dontHaveAccount: "¿No tienes una cuenta?",
    errorDescription: "Ha ocurrido un error",
    errorTitle: "Error",
    successTitle: "Éxito",
    successDescription: "Operación exitosa",
    continueWithGoogle: "Continuar con Google",
    createAccount: "Crear cuenta",
    trialDescription: "Prueba gratuita de 14 días",
    emailPlaceholder: "tu@email.com",
    creating: "Creando...",
    create: "Crear",
    errorMessage: "Ha ocurrido un error"
  },
  navigation: {
    pricing: "Precios",
    about: "Acerca de",
    contact: "Contacto",
    themes: "Temas",
    resources: "Recursos",
    home: "Inicio",
    dashboard: "Panel",
    products: "Productos",
    orders: "Pedidos",
    customers: "Clientes",
    settings: "Ajustes"
  },
  footer: {
    acceptedPayments: "Pagos aceptados",
    allRightsReserved: "Todos los derechos reservados",
    quickLinks: "Enlaces rápidos",
    legalNotice: "Aviso legal",
    accessibility: "Accesibilidad",
    termsOfUse: "Términos de uso",
    support: "Soporte",
    followUs: "Síguenos",
    socialMedia: "Encuéntranos en redes sociales",
    newsletter: "Boletín",
    subscribeNewsletter: "Suscríbete a nuestro boletín",
    emailPlaceholder: "Tu email",
    subscribe: "Suscribirse",
    changeLanguage: "Cambiar idioma"
  },
  pricing: {
    title: "Planes y precios",
    subtitle: "Elige el plan que más te convenga",
    startTrial: "Comenzar prueba gratuita",
    mostPopular: "Más popular",
    freeTrial: "14 días de prueba gratuita",
    perMonth: "/mes",
    basic: {
      name: "Básico",
      price: "11",
      description: "Para comenzar",
      features: [
        "1 tienda",
        "100 productos",
        "Soporte por email"
      ]
    },
    pro: {
      name: "Pro",
      price: "25",
      description: "Para profesionales",
      features: [
        "3 tiendas",
        "1000 productos",
        "Soporte prioritario",
        "Análisis avanzado"
      ]
    },
    enterprise: {
      name: "Empresa",
      price: "97",
      description: "Para grandes empresas",
      features: [
        "Tiendas ilimitadas",
        "Productos ilimitados",
        "Soporte dedicado",
        "API personalizada"
      ]
    }
  },
  profile: {
    title: "Mi Perfil",
    fullName: "Nombre completo",
    phoneNumber: "Número de teléfono",
    update: "Actualizar",
    updating: "Actualizando...",
    success: "Perfil actualizado con éxito",
    error: "Error al actualizar el perfil"
  },
  common: {
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    create: "Crear",
    search: "Buscar",
    filter: "Filtrar",
    sort: "Ordenar",
    actions: "Acciones",
    confirm: "Confirmar",
    back: "Atrás",
    next: "Siguiente",
    previous: "Anterior",
    close: "Cerrar"
  }
};
